import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../../components/Breadcrumb';
import Swal from 'sweetalert2';
import { createAccount } from '../../../axios/AccountAxios';
import { useNavigate } from 'react-router-dom';
import LoadingOverlay from '../../../components/LoadingOverlay';

function AccountAdd() {
  const breadcrumbItems = [
    { label: 'Dashboard', href: '/' },
    { label: 'Account', href: '/account' },
    { label: 'Create Account' },
  ];

  const navigation = useNavigate();

  const [formData, setFormData] = useState({
    account_code: '',
    name1: '',
    name2: '',
    name3: '',
    name4: '',
    name5: '',
    level: '',
    group: '',
    condition: '',
    report: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const forms = document.querySelectorAll('.needs-validation');
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        'submit',
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add('was-validated');
        },
        false
      );
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const formElements = Array.from(e.target.form.elements);
      const index = formElements.indexOf(e.target);
      formElements[index + 1]?.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    if (!form.checkValidity()) {
      form.classList.add('was-validated');
      return;
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary mx-1', // Bootstrap primary button
        denyButton: 'btn btn-danger mx-1', // Bootstrap warning button
        cancelButton: 'btn btn-secondary mx-1', // Bootstrap secondary button
      },
      buttonsStyling: false,
    });

    try {
      const result = await swalWithBootstrapButtons.fire({
        title: 'Do you want to save the data?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Save',
        cancelButtonText: `Don't save`,
      });

      if (result.isConfirmed) {
        try {
          setMessage('Saving data...');
          setLoading(true);
          // Coba buat akun
          await createAccount(formData);
          // Jika berhasil, tampilkan pesan sukses
          swalWithBootstrapButtons.fire(
            'Saved!',
            'The account has been created.',
            'success'
          );
          navigation('/account');
        } catch (createAccountError) {
          // Jika ada kesalahan saat membuat akun, tampilkan pesan kesalahan
          swalWithBootstrapButtons.fire({
            title: 'Error!',
            text: createAccountError.message,
            icon: 'error',
          });
        } finally {
          setLoading(false);
        }
      } else if (result.isDenied) {
        swalWithBootstrapButtons.fire('Changes are not saved', '', 'info');
      }
    } catch (error) {
      let errorMessage = 'There was an error processing your request.';

      // Cek apakah error memiliki response dan data
      if (error.response && error.response.data) {
        // Cek apakah ada pesan error spesifik di dalam data
        errorMessage =
          error.response.data.message ||
          error.response.data.error ||
          errorMessage;
      } else if (error.message) {
        // Jika error adalah objek JavaScript biasa dengan pesan
        errorMessage = error.message;
      }

      swalWithBootstrapButtons.fire({
        title: 'Error!',
        text: errorMessage,
        icon: 'error',
      });

      console.log(errorMessage);
    }
  };

  const handleCancel = (event) => {
    event.preventDefault();

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary mx-1', // Bootstrap primary button
        denyButton: 'btn btn-danger mx-1', // Bootstrap warning button
        cancelButton: 'btn btn-secondary mx-1', // Bootstrap secondary button
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: 'All your input will be lost!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, cancel it!',
        cancelButtonText: 'No, keep it',
      })
      .then((result) => {
        if (result.isConfirmed) {
          const form = document.querySelector('.needs-validation');
          form.reset();
          setFormData({
            account_code: '',
            name1: '',
            name2: '',
            name3: '',
            name4: '',
            name5: '',
            level: '',
            group: '',
            condition: '',
            report: '',
          });
          form.classList.remove('was-validated');
        }
      });
  };

  return (
    <div>
      <LoadingOverlay show={loading} message={message} />
      <Breadcrumb items={breadcrumbItems}></Breadcrumb>

      <form
        className="needs-validation"
        autocomplete="off"
        noValidate
        onSubmit={handleSubmit}
      >
        <div className="row">
          <div className="col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="mb-3">
                  <label htmlFor="validationAccCode" className="form-label">
                    Account Code
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="validationAccCode"
                    name="account_code"
                    value={formData.account_code}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Name 1</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="name1"
                    value={formData.name1}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Name 2</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="name2"
                    value={formData.name2}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Name 3</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="name3"
                    value={formData.name3}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Name 4</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="name4"
                    value={formData.name4}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Name 5</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="name5"
                    value={formData.name5}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col mb-3">
                    <label className="form-label">Level</label>
                    <select
                      className="form-select form-select-sm"
                      aria-label="Small select example"
                      name="level"
                      value={formData.level}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Choose...</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                    <div className="invalid-feedback">Cannot be empty.</div>
                  </div>
                  <div className="col mb-3">
                    <label className="form-label">Group</label>
                    <select
                      className="form-select form-select-sm"
                      aria-label="Small select example"
                      name="group"
                      value={formData.group}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Choose...</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                      <option value="E">E</option>
                      <option value="F">F</option>
                      <option value="G">G</option>
                      <option value="H">H</option>
                      <option value="I">I</option>
                      <option value="J">J</option>
                      <option value="K">K</option>
                      <option value="L">L</option>
                      <option value="M">M</option>
                      <option value="N">N</option>
                      <option value="O">O</option>
                      <option value="P">P</option>
                      <option value="Q">Q</option>
                      <option value="R">R</option>
                      <option value="S">S</option>
                      <option value="T">T</option>
                      <option value="U">U</option>
                      <option value="V">V</option>
                      <option value="W">W</option>
                      <option value="X">X</option>
                      <option value="Y">Y</option>
                      <option value="Z">Z</option>
                    </select>
                    <div className="invalid-feedback">Cannot be empty.</div>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Condition</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="condition"
                    value={formData.condition}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Report</label>
                  <textarea
                    className="form-control form-control-sm"
                    rows="5"
                    name="report"
                    value={formData.report}
                    onChange={handleChange}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
              </div>
            </div>
            <div className="button-navigatsi">
              <div className="">
                <button type="submit" className="btn btn-primary">
                  <i className="bi bi-send"></i>
                  <span> Submit</span>
                </button>
              </div>
              <div className="">
                <button
                  type="reset"
                  className="btn btn-danger btn-cancel"
                  onClick={handleCancel}
                >
                  <i className="bi bi-x-circle"></i>
                  <span> Cancel</span>
                </button>
              </div>
              <div className="">
                <Link type="button" className="btn btn-warning" to="/account">
                  <i className="bi bi-arrow-left-circle"></i>
                  <span> Back</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AccountAdd;
